module.exports = __webpack_public_path__ + "img/mtTableF.f06f34db.svg";